import { tellTales } from "./TellTales";

export const REASON_NA = "N/A";

/** Geotab's system driver for trips nobody was logged in for. */
export const UNKNOWN_DRIVER_ID = "UnknownDriverId";

export const DEFAULT_DIAGNOSTICS_DIAGNOSTICMONITOR = [
  "DiagnosticElectricVehicleBatteryPowerId",
  "DiagnosticIgnitionId",
  "DiagnosticElectricVehicleChargingStateId",
  "DiagnosticOdometerId",
  "a8Q59homXrESC9eF_I_JTWA", // Parking brake telltale
  "agOXwO-vH0EW66Ry_cjkJrg", // Calibration
];

export const COCKPIT_DIAGNOSTICS = [
  "DiagnosticOutsideTemperatureId",
  "DiagnosticFuelLevelId",
  "DiagnosticEngineSpeedId",
  "DiagnosticDieselExhaustFluidId",
  "DiagnosticEngineCoolantTemperatureId",
  "DiagnosticStateOfChargeId",
  "DiagnosticCabInteriorTemperatureId",
  "DiagnosticDoor1StatusId",
  "DiagnosticDoor2StatusId",
  "aMkXsw2rqV0-pxn4ko_qlnA", // Door 3
  "DiagnosticElectricVehicleBatteryPowerId",
];

/**
 * What the live map asks every visible vehicle for, beyond its position.
 *
 * Named one by one rather than read out of the list by position: the map reads each of these back
 * by name, and an id inserted in the middle of a positional list would silently have it draw the
 * tank as the battery.
 *
 * Kept short on purpose. This is polled every two seconds for every vehicle on screen, so each id
 * here is paid for on every tick of a whole fleet.
 */
export const DIAGNOSTIC_STATE_OF_CHARGE_ID = "DiagnosticStateOfChargeId";
export const DIAGNOSTIC_FUEL_LEVEL_ID = "DiagnosticFuelLevelId";
export const DIAGNOSTIC_CHARGING_STATE_ID = "DiagnosticElectricVehicleChargingStateId";
/** AdBlue. */
export const DIAGNOSTIC_DEF_LEVEL_ID = "DiagnosticDieselExhaustFluidId";

export const MAP_DIAGNOSTICS = [
  DIAGNOSTIC_STATE_OF_CHARGE_ID,
  DIAGNOSTIC_FUEL_LEVEL_ID,
  DIAGNOSTIC_CHARGING_STATE_ID,
  DIAGNOSTIC_DEF_LEVEL_ID,
];

export const TELLTALES_DIAGNOSTICS = tellTales
  .filter(t => !t?.name?.includes("Reserved for"))
  .map(d => d.id);
